// AddCourseRecordDialog/index.js
import { connect } from 'react-redux';
import AddCourseRecordDialog from '../../components/AddCourseRecordDialog';

import {
  openAddCourseRecordDialogDispatch,
  onHandleInputChange,
  submitCourseRecordDispatch,
  fetchAllPersonnelsDispatch,
  fetchAllCoursesForBranchDispatch,
  removeCourseRecordAttachment
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    branchId: state.branch.branch.item && state.branch.branch.item.id,
    course: state.course.newCourse.item,
    openDialog: state.course.newRecord.openAddCourseRecordDialog,
    isSaving: state.course.newRecord.isSaving,
    errorMessage: state.course.newRecord.errorMessage,
    personnelId: state.course.newRecord.item.personnelId,
    personnels: state.personnels.allPersonnels.items,
    record: state.course.newRecord.item,
    courses: state.courses.coursesByBranch.items,
    dialogOpenRequestSource: state.course.newRecord.dialogOpenRequestSource,
    allAttachments: state.course.newRecord.item.attachmentFiles
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onOpenAddCourseRecordDialog: (open, personnelId) => {
      dispatch(openAddCourseRecordDialogDispatch(open, personnelId));
    },
    onHandleInputChange: (value, inputFieldName) => {
      dispatch(onHandleInputChange(value, inputFieldName));
    },
    submitRecord: (payload, mode, source, branchId) => {
      dispatch(submitCourseRecordDispatch(payload, mode, source, branchId));
    },
    fetchAllPersonnels: (branchId) => {
      dispatch(fetchAllPersonnelsDispatch(branchId));
    },
    fetchAllCoursesForBranch: (branchId) => {
      dispatch(fetchAllCoursesForBranchDispatch(branchId));
    },
    onRemoveAttachment: (attachment) => {
      dispatch(removeCourseRecordAttachment(attachment));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddCourseRecordDialog);
